export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';


export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';

export const SAVE_CONFIG = 'SAVE_CONFIG';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js